export const DEFAULT_LOCKED_TIMESHEET_MESSAGE = `Please note: This timesheet cannot be changed.
    Please contact your Consultant if you have any questions.`;
export const TIMESHEET_CONNECTION_ERROR = `A network issue has prevented getting data for this timesheet.
    Please try again in a few minutes.`;
export const TIMESHEET_CREATION_ERROR = `A network issue has prevented getting data for this timesheet.
    Please try again in a few minutes.`;
